/**
 * EverWithin PDP helpers — reserved for future below-fold deferrals.
 * jQuery remains deferred via theme.liquid; FBT uses native IntersectionObserver.
 */
(function () {
  'use strict';
  // Soft-hint: skip decoding work for offscreen gallery thumbs if browser supports it
  document.querySelectorAll('.thumbnail-list img[loading="lazy"]').forEach(function (img) {
    if (!img.getAttribute('decoding')) img.setAttribute('decoding', 'async');
    if (!img.getAttribute('fetchpriority')) img.setAttribute('fetchpriority', 'low');
  });
})();
